// extracted by mini-css-extract-plugin
export default {"tooltip":"oL-z","arrow":"pL-z"};